import {
  type LoadExchangeRateInput,
  useQuery,
  useExchangeRatesForLoad as useSharedExchangeRatesForLoad,
} from '@fv/client-core'
import type { Currency, ExchangeRateMap } from '@fv/models'

import { shipperFetch } from '@/utils/shipperFetch'

export function useExchangeRates(enabled = true, date?: Date | string) {
  const dateStr = date ? new Date(date).toISOString() : undefined
  return useQuery<ExchangeRateMap>(
    ['exchange-rates', dateStr],
    () =>
      shipperFetch<ExchangeRateMap>('/exchange-rates', {
        query: { ...(dateStr && { date: dateStr }) },
      }),
    {
      enabled,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 60,
    },
  )
}

export function useExchangeRatesForLoad(
  load: LoadExchangeRateInput | undefined,
  enabled: boolean,
): ExchangeRateMap {
  return useSharedExchangeRatesForLoad(load, enabled, useExchangeRates)
}

export type ConvertedAmount = { amount: number; currency: Currency }

export function convertCurrency(
  amount: number,
  fromCurrency: Currency,
  toCurrency: Currency,
  rates: ExchangeRateMap,
): ConvertedAmount {
  if (fromCurrency === toCurrency) return { amount, currency: toCurrency }

  let usdAmount: number
  if (fromCurrency === 'usd') {
    usdAmount = amount
  } else {
    const fromRate = rates[fromCurrency]
    if (!fromRate) return { amount, currency: fromCurrency }
    usdAmount = amount / fromRate
  }

  if (toCurrency === 'usd') return { amount: usdAmount, currency: 'usd' }

  const toRate = rates[toCurrency]
  if (!toRate) return { amount, currency: fromCurrency }

  return { amount: usdAmount * toRate, currency: toCurrency }
}
